import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import CircularProgress from '@material-ui/core/CircularProgress';
import useTranslation from 'Hooks/useTranslation';

/** Template picker in the same table look as JobTableList (shared .jobTable styles). */
const TemplateTableList = ({ templates = [], value, onChange, isLoading = false }) => {
    const translation = useTranslation();

    return (
        <div className="jobTable jobTable--templates">
            <div className="jobTableHead" role="row">
                <span className="jobTableCell jobTableCell--radio" aria-hidden="true" />
                <span className="jobTableCell jobTableCell--name">{translation.dashboardTemplatesLabel || 'Templates'}</span>
                <span className="jobTableCell jobTableCell--date">{translation.dashboardTemplatesUpdatedAtLabel || 'Updated at'}</span>
            </div>
            <div className="jobTableBody">
                <RadioGroup aria-label="templates" name="templates" value={value ? String(value) : ''}>
                    {templates.map((template) => {
                        const id = String(template.id);
                        const selected = value != null && String(value) === id;
                        return (
                            <label
                                key={template.id}
                                className={`jobTableRow${selected ? ' jobTableRow--selected' : ''}`}
                                id={`templateListItemBtn-${template.id}`}
                            >
                                <span className="jobTableCell jobTableCell--radio">
                                    <Radio
                                        value={id}
                                        size="small"
                                        color="default"
                                        checked={selected}
                                        onChange={() => onChange?.(template.id)}
                                    />
                                </span>
                                <span className="jobTableCell jobTableCell--name" title={template.name}>{template.name}</span>
                                <span className="jobTableCell jobTableCell--date">
                                    {template.updatedAt ? new Date(template.updatedAt).toLocaleString() : '—'}
                                </span>
                            </label>
                        );
                    })}
                </RadioGroup>
                {!templates.length && !isLoading ? (
                    <div className="jobTableEmpty">{translation.dashboardNoTemplatesLabel || 'No templates found'}</div>
                ) : null}
            </div>
            {isLoading ? (
                <div className="jobTableLoader">
                    <CircularProgress size={28} />
                </div>
            ) : null}
        </div>
    );
};

export default TemplateTableList;
